import { httpService } from "./http.service.js";
import axios from 'axios';
const BASE_URL = "grupos/";

export const grupoService = {
  query,
  getGroupsWithActivities,
  getGroupsWithUsuarios,
  getGroupslistaUsuarios,
  getGroupsWithProyecto,
  guardarActividad,
  guardarSubActividad,
  actualizarActividad,
  actualizarSubActividad,
  actualizarGrupo,
  AgregarGrupo,
  getEmptyGroup2,
  guardarArchivos,
  deleteActividad,
  archivarActividad,
  getProyectoAll,
  getGroupsWithParams,
  VisualizarArchivo,
  deshabilitarArchivos,
  DuplicarGrupo,
  MoverGrupoaTablero,
  movetaskgroup,
  EvaluacionMVerificacion,
  getdataArchivo,
  getDataByIDArchivo,
  NotificacionMedioVerificacion,
  RemplazarArchivos,
  FilterAvanceTask,
  FilterAvanceTaskUsers,
  converSubTask,
  getDataModulos,
  UpdatepositionTask,
  UpdatepositionSubTask,
  getUserTablero,
  assignUserBoard,
  ChangePasswordUser

};

function getEmptyGroup2() {
  return {
      "nombre_grupo": '',
      "estado": '',
      "fk_tableros_id": '',
      "color": '#ffcb00',
      "actividades": [],
  }
}


//funcion de prueba
function movetaskgroup(idgroup, idstask) {
  const queryParams = 'movetask';
  return httpService.put(`actividades/${queryParams}/${idgroup}/${idstask}`);
}

//Convertir una sub actividad en una actividad
function converSubTask(idgroup, idstask) {
  const queryParams = 'ConversubTask';
  return httpService.get(`subactividades/${queryParams}/${idstask}/${idgroup}`);
}


function getDataModulos(id_region) {
  const queryParams = `obtener-informacion`;
  return httpService.get(`tablero/${queryParams}/${id_region}`);

 
}

//-----------------Funciones para Tableros--------------------//
function getUserTablero(id_tablero) {
  const queryParams = `getUserTablero`;
  return httpService.get(`detallesTablero/${queryParams}/${id_tablero}`);

 
}

function assignUserBoard(tableroDetalle ) {
    const queryParams = `actualizar`;
    return httpService.put(`detallesTablero/${queryParams}/${tableroDetalle.fk_tablero_id}/${tableroDetalle.fk_usuario_id}`,tableroDetalle);
}

//-------------------------------------//

//Funcion para cambiar de posicion las actividades
function UpdatepositionTask(OrderTasks) {
  const queryParams = `UpdatePElemento`;
  return httpService.put("actividades/" + queryParams, OrderTasks);
}

//Funcion para cambiar de posicion las subactividades
function UpdatepositionSubTask(OrderTasks) {
  const queryParams = `UpdateSubPElemento`;
  return httpService.put("subactividades/" + queryParams, OrderTasks);
}



function query() {
  const queryParams = `all`;
  return httpService.get(BASE_URL + queryParams);
}

//Funcion Reutilizable 
function getGroupsWithParams(endpoint, params) {
  const queryParams = Object.values(params).join('/');
  return httpService.get(`${endpoint}/${queryParams}`);
}

// Grupo service
function getGroupsWithActivities(idTablero) {
  const queryParams = `actividades`;
  return httpService.get(`grupos/${queryParams}/${idTablero}`);

 
}

 //traer las actividades por usuario
 function getGroupsWithUsuarios(idTablero, idUsuario) {
  const queryParams = 'getGruposWithUsuarios';
  return httpService.get(`grupos/${queryParams}/${idTablero}/${idUsuario}`);
}

 //traer las actividades por lista de usuarios
 function getGroupslistaUsuarios(idTablero, idUsuario) {
  const queryParams = 'getGruposlistaUsuarios';
  return httpService.get(`grupos/${queryParams}/${idTablero}/${idUsuario}`);
}

//Funcion para actualizar la contraseña del usuario
function ChangePasswordUser(infoUsers) {
  console.log("servicio",infoUsers);
  const queryParams = 'changePassword';
  return httpService.post(`usuarios/${queryParams}`, infoUsers);
}

 //traer las actividades por proyectos
 function getGroupsWithProyecto(idTablero, idUsuario, idProyecto) {
  const queryParams = 'actividadesForProyec';
  return httpService.get(`grupos/${queryParams}/${idTablero}/${idUsuario}/${idProyecto}`);
}

 //traer las actividades por proyectos
 function getProyectoAll(idTablero, idProyecto) {
  const queryParams = 'getProyectosAll';
  return httpService.get(`grupos/${queryParams}/${idTablero}/${idProyecto}`);
}


function guardarActividad(actividad) {
  const queryParams = `guardar`;
  return httpService.post("actividades/" + queryParams, actividad);
}

//eliminar actividad 
function deleteActividad(idactividad) {
  const queryParams = `eliminar`;
  return httpService.delete(`actividades/${queryParams}/${idactividad}`);
}

//Funcion para filtrar 


//funcion para filtrar datos con el filtro general 
function FilterAvanceTask(formData,idTablero,filtroDate) {
  const queryParams = `filtrar`;
  return httpService.post(`actividades/${queryParams}/${idTablero}/${filtroDate}`, formData);
}

//funcion para filtrar datos por filtro general y usuario Responsable
function FilterAvanceTaskUsers(formData,idTablero,idResponsable, filtroStatus) {
  const queryParams = `filtrarResponsable`;
  return httpService.post(`actividades/${queryParams}/${idTablero}/${filtroStatus}/${idResponsable}`, formData);
}


//-----------------Funciones para archivosActividad--------------------//

//funcion para guardar los archivos que se agregen al panel
function guardarArchivos(formData) {
  const queryParams = `guardar`;
  return httpService.post("archivosActividad/" + queryParams, formData);
}



//Funcion para remplazar los archivos

function RemplazarArchivos(formData, id_archivo) {
  
 
  const queryParams = `remplazarArchivo`;
  return httpService.post(`archivosActividad/${queryParams}/${id_archivo}`, formData);
  
}


//funcion guardar en DRIVE
// function guardarArchivos(formData) {
//   const queryParams = `guardarArchivo`;
//   return httpService.post("drive/"+ queryParams,formData);
// }

//Eliminar archivo
async function deshabilitarArchivos(idArchivo) {
  const queryParams = `deshabilitar`;
  const estado = await httpService.put(`archivosActividad/${queryParams}/${idArchivo}`);
  return estado;
}


// función para descargar un archivo de la API
// function VisualizarArchivo(idArchivo) {
//   const fileUrl = `https://planificaciontest.cderl.com/archivosActividad/visualizar/${idArchivo}`;
//   window.open(fileUrl, '_blank');
// }

//funcion de prueba

export async function VisualizarArchivo(idArchivo) {
  const primaryUrl = `https://planificaciontest.cderl.com/archivosActividad/visualizar/${idArchivo}`;
  const fallbackUrl = `https://planificacionapi.cderl.com/archivosActividad/visualizar/${idArchivo}`;

  // Función para verificar si una URL existe usando una solicitud HEAD
  const checkFileExists = async (url) => {
    try {
      const response = await axios.head(url);
      return response.status === 200;
    } catch (error) {
      return false;
    }
  };

  try {
    // Verificar la primera URL
    const primaryExists = await checkFileExists(primaryUrl);
    if (primaryExists) {
      window.open(primaryUrl, '_blank');
      return;
    }

    // Si no existe en la primera URL, verificar la segunda
    const fallbackExists = await checkFileExists(fallbackUrl);
    if (fallbackExists) {
      window.open(fallbackUrl, '_blank');
      return;
    }

    // Si no existe en ninguna de las dos, notificar al usuario
    console.log('No existe el archivo solicitado.');
  } catch (error) {
    // Manejar errores inesperados
    console.error('Error al verificar el archivo:', error);
    
  }
}



//visualizar archivos de drive
// async function VisualizarArchivo(idArchivo) {
//   try {
//     // Llama a la API para obtener la URL del archivo
//     const response = await httpService.get(`drive/VisualizarArchivo/${idArchivo}`);
    
//     // Asegúrate de que la respuesta contiene la propiedad 'fileUrl'
//     if (response && response.fileUrl) {
//       const fileUrl = response.fileUrl; // Obtén la URL del archivo desde la respuesta
//       // Abre la URL en una nueva ventana
//       window.open(fileUrl, '_blank');
//     } else {
//       console.error('La URL del archivo no está disponible en la respuesta.');
//     }
//   } catch (error) {
//     console.error('Error al visualizar el archivo:', error);
//   }
// }


//Funcion para rechazar medios de verificacion

function EvaluacionMVerificacion(formData, ID_medio) {
  const queryParams = `actualizar`;
  return httpService.put(`mediosVerifiacion/${queryParams}/${ID_medio}`, formData);
}


//Funcion para OBTENER todo el historico del documento:
function getdataArchivo(ID_Actividad) {
  const queryParams = `getData`;
  return httpService.get(`mediosVerifiacion/${queryParams}/${ID_Actividad}`);
}

//Funcion para obtener  el historico del documento Por IDENTIFICADOR:
function getDataByIDArchivo(ID_Archivo) {
  const queryParams = `getDataByID`;
  return httpService.get(`mediosVerifiacion/${queryParams}/${ID_Archivo}`);
}

//Funcion para enviar las notificaciones a los correos 
function NotificacionMedioVerificacion(ID_Archivo, IdGrupo) {
  const queryParams = `noticheck`;
  return httpService.get(`mediosVerifiacion/${queryParams}/${ID_Archivo}/${IdGrupo}`);
}





//-----------------Funciones para archivosActividad--------------------//


// async function actualizarActividad(task) {
//   try {
//       const updatedTask = await httpService.put(`actividades/actualizar/${task.id_actividad}`, task);
//       return updatedTask;
//   } catch (err) {
//       console.log('Error updating task:', err);
//       throw err;
//   }
// }



function actualizarActividad(actividad) {
  const queryParams = `actualizar/${actividad.id_actividad}`;
  return httpService.put("actividades/" + queryParams, actividad)
      .then(response => {
          
          return response.data;
      })
      .catch(error => {
          console.error('Error en la petición PUT:', error.response ? error.response.data : error.message);
          throw error;
      });
}


// Método para actualizar una sub-actividad
function actualizarSubActividad(subActividad) {
  const queryParams = 'actualizar';
  return httpService.put(`subactividades/${queryParams}/${subActividad.id_subactividad}`, subActividad);
}

function guardarSubActividad(subactividad) {
  const queryParams = `guardar`;
  return httpService.post("subactividades/" + queryParams, subactividad);
}

//Funciones grupos


function AgregarGrupo(actividad) {
  const queryParams = `guardar`;
  return httpService.post("grupos/" + queryParams, actividad);
}


async function actualizarGrupo(groupId, groupData) {
  try {
    const queryParams = 'actualizar';
    return httpService.put(`grupos/${queryParams}/${groupId}`, groupData);
  } catch (error) {
      console.error('Error actualizando el grupo:', error);
      throw error;
  }
}

function DuplicarGrupo(idTablero, idGrupo) {
  const queryParams = `duplicar`;
  return httpService.post(`grupos/${queryParams}/${idTablero}/${idGrupo}`);
}

function MoverGrupoaTablero(idGrupo,idTablero) {
  const queryParams = `MoveraTablero`;
  return httpService.put(`grupos/${queryParams}/${idGrupo}/${idTablero}`);
}


// function archivarActividad(id, context){
//   return httpService.put(`${context}/archivar/${id}`, {archivada:1});
// }

function archivarActividad(ids, context) {
  return httpService.put(`${context}/archivar`, { ids, archivada: 1 });
}

